// removed by extract-text-webpack-plugin
module.exports = {"mainTitle":"_3c64BZfr6xyvvcXnLdBWaY","subtitle":"_2Bm88RVl2XnUdkwYoNzu6d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Title/Title.css
// module id = 37
// module chunks = 0